export class BackupReportParseError extends Error {
  // This gives the error type safety
  private readonly typeName = 'BackupReportParseError'
  public readonly name = this.typeName

  constructor(message: string) {
    super(`Error while parsing backup report: ${message}`)
  }
}
